import { createFileRoute } from "@tanstack/react-router";
import { GameScreen } from "@/screens/GameScreen.tsx";
import { GameMachineProvider } from "@/machines/GameProvider.tsx";
import { getInstanceIdFromSubdomain } from "@/utils/subdomain";

export const Route = createFileRoute("/game")({
  component: RouteComponent,
  loader: () => {
    const instanceId = getInstanceIdFromSubdomain();
    if (!instanceId) {
      throw new Error("No instance ID found in subdomain");
    }
    return { instanceId };
  },
  remountDeps: () => {
    const instanceId = getInstanceIdFromSubdomain();
    return ["game", instanceId];
  },
});

function RouteComponent() {
  const { instanceId } = Route.useLoaderData();

  return (
    <GameMachineProvider instanceId={instanceId}>
      <GameScreen />
    </GameMachineProvider>
  );
}
